import { createApp as u, h as p } from "vue";
import l from "./message-box.vue.js";
/* empty css                 */
import "../../hooks/use-z-index.js";
import { useId as d } from "../../hooks/use-id.js";
const e = (o) => new Promise((t, n) => {
  const r = document.createElement("div"), i = "dialog-" + d().value;
  r.id = i, document.body.appendChild(r);
  const m = {
    visible: !0,
    ...o
  }, a = () => {
    c.unmount(), r.remove();
  }, c = u({
    render() {
      return p(l, {
        ...m,
        "onUpdate:visible": (s) => {
          s === !1 && a();
        },
        callback: (s) => {
          (s === "confirm" ? t : n)(s);
        }
      });
    }
  });
  c.mount(r);
});
e.open = e;
e.alert = (o, t, n) => e({
  title: t,
  message: o,
  showCancelButton: !1,
  ...n
});
e.confirm = (o, t, n) => e({
  title: t,
  message: o,
  showConfirmButton: !0,
  showCancelButton: !0,
  confirmButtonText: "OK",
  cancelButtonText: "Cancel",
  ...n
});
const C = e;
export {
  C as ApMessageBox
};
